import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { applyTheme, getSelectedTheme } from './themes';
import { msalInstance } from './auth/LoginButton';

// Apply saved theme immediately on app load, before any rendering
applyTheme(getSelectedTheme());

// Initialize MSAL and process any OAuth redirect response BEFORE React Router
// mounts and strips the ?code= query param from the URL.
msalInstance.initialize().then(() => {
  return msalInstance.handleRedirectPromise();
}).catch((e) => {
  console.error('[main.tsx] MSAL init/redirect error:', e);
}).finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
